import { getDynamicConfig } from "infrastructure/configuration/configurationHelper";

const dynamicConfig = getDynamicConfig();

export const getPortalRootUrl = (): string => {
  if (dynamicConfig.portalUrlBasename) {
    return `${window.location.origin}${dynamicConfig.portalUrlBasename}`;
  }

  return `${window.location.origin}`;
}

export const getUrl = (suffixPath: string): string => {
  return `${getPortalRootUrl()}/${suffixPath}`;
}

export const getPortalBasename = (suffixPath?: string): string => {
  let basename = dynamicConfig.portalUrlBasename ?? "";

  if (suffixPath) {
    return `${basename}/${suffixPath}`;
  }

  return basename;
}

export const getChangePasswordUrl = (): string => {
  const is4Url = dynamicConfig.identityServerUrl;
  const clientId = dynamicConfig.identityServerClientId;

  return `${is4Url}/Manage/ChangePassword?fromUi=true&clientId=${clientId}`;    
}

export const getResetPasswordUrl = (): string => {
  const is4Url = dynamicConfig.identityServerUrl;

  return `${is4Url}/Account/ForgotPassword?redirectUrl=${getPortalRootUrl()}`;
}

export const redirectToUrl = (url: string) => {
  document.location.href = url;
}